import React from 'react';
import moment from 'moment';
import ReportDropDown from '../../components/reportDropDown';
import {systemTypeNamesFormat, reportDateFormat} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

import events from '../../../../../lib/events.js';

import EditableDatePicker from '../../../../components/forms/editableDatePicker.jsx';

class TotalAnalysesOptions extends React.Component {
  state = {
  };

  componentWillMount() {
    this.resetFilters();
  }

  updateData = () => {
    this.props.updateReportData(
			moment(this.state.dateFrom).format(dateTimeFormats.numeralDate),
			moment(this.state.dateTo).format(dateTimeFormats.numeralDate),
			this.state.store,
			this.state.systemType,
		);
  };

  updateDates = (data) => {
    if(data.key === 'dateFrom') {
      if(this.validateDates(data.value, this.state.dateTo)) {
        this.setState({
          dateFrom: data.value,
        });
      }
    } else if(data.key === 'dateTo') {
      if(this.validateDates(this.state.dateFrom, data.value)) {
        this.setState({
          dateTo: data.value,
        });
      }
    }
  };

  resetFilters() {
    let filters = this.props.defaultFilters;

    this.setState({
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      store: filters.store,
      systemType: filters.systemType,
    });
  }

  validateDates = (dateFrom, dateTo) => {
    if(moment(dateFrom).isAfter(dateTo)) {
      events.publish('error.user', {
        message: this.props.intl.formatMessage({id: 'general.error.invalid.dates'}),
        key: 'invalidDates',
      });
      return false;
    }
    return true;
  };

  render() {

    let stores = [];
    let systemTypes = [];
    let {formatMessage} = this.props.intl;
    let systemTypeNames = systemTypeNamesFormat(formatMessage);

    if(this.props.branches !== null && this.props.branches !== undefined && this.props.branches.length > 0) {
      var obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) {
        return {value: obj[key].id, label: obj[key].name};
      });

      stores.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    systemTypes = Object.keys(systemTypeNames).map(function(key) {
      return {value: key, label: systemTypeNames[key]};
    });
    systemTypes.unshift({value: 0, label: formatMessage({id: 'general.all.systems'})});

    return (
      <div className="report-options" >
        <div className="top-title-bar" >
          <FormattedMessage id="general.report.options" />
        </div>
        <div className="select-options container-fluid">
          <div className="row">
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.from" /></label>
                <EditableDatePicker
									onChange={this.updateDates}
									dataKey='dateFrom'
									value={this.state.dateFrom}
									maxDate={moment(this.state.dateTo).clone().subtract(1, 'days')}
									editMode={true}
									dateFormat={reportDateFormat} />
              </div>
            </div>
            <div className="col-sm-3">
              <div className='form-group'>
                <label><FormattedMessage id="general.date.to" /></label>
                <EditableDatePicker
									onChange={this.updateDates}
									dataKey='dateTo'
									value={this.state.dateTo}
									minDate={moment(this.state.dateFrom).clone()}
									maxDate={moment()}
									editMode={true}
									dateFormat={reportDateFormat} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <ReportDropDown value={this.state.store} label={formatMessage({id: 'general.store'})}
							onChange={((e) => {
  this.setState({store: e.target.value});
})}
							options={stores} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.systemType} label={formatMessage({id: 'general.system.type'})}
							onChange={((e) => {
  this.setState({systemType: e.target.value});
})}
							options={systemTypes} />
            </div>
          </div>
        </div>
        <div className="manage-options">
          <div className="col-sm-12 button-group">
            <a className="reset-button pull-right" onClick={this.resetFilters}><FormattedMessage id="general.reset" /></a>
            <a className="btn btn-primary pull-right" onClick={this.updateData}><FormattedMessage id="reports.update.summary" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(TotalAnalysesOptions);
